__turbopack_context__.v({
  "arrow": "styles-module-scss-module__OfNnQG__arrow",
  "calendarIcon": "styles-module-scss-module__OfNnQG__calendarIcon",
  "label": "styles-module-scss-module__OfNnQG__label",
  "labelText": "styles-module-scss-module__OfNnQG__labelText",
  "option": "styles-module-scss-module__OfNnQG__option",
  "options": "styles-module-scss-module__OfNnQG__options",
  "select": "styles-module-scss-module__OfNnQG__select",
  "selectRoot": "styles-module-scss-module__OfNnQG__selectRoot",
  "selectRootShow": "styles-module-scss-module__OfNnQG__selectRootShow",
});
